/* NOTE23 Medaillon \u2013 Fotos + Gravur + Live-Vorschau (v4) */
(function(){
'use strict';
function boot(){
var root = document.querySelector('[data-n23m]');
if (!root || root.__n23m) return;
root.__n23m = true;
root.classList.add('n23m');

var FORM = root.getAttribute('data-form') || '';
if (!document.getElementById(FORM)) { var f0 = document.querySelector('form[id^="BuyButtons-ProductForm"]'); if (f0) FORM = f0.id; }
var L = (root.getAttribute('data-loc') || document.documentElement.lang || 'de').slice(0,2).toLowerCase();
var HANDLE = root.getAttribute('data-handle') || (location.pathname.split('/products/')[1] || '').split(/[\/?#]/)[0];
var CDN = root.getAttribute('data-cdn') || '/cdn/shop/files/';
var DESIGN = /initial/.test(HANDLE) ? 'initial' : /name.*datum|name-date|namn/.test(HANDLE) ? 'namedate' : /famil/.test(HANDLE) ? 'family' : 'foto';

var T = {
de:{color:'Farbe',silver:'Silber',gold:'Gold',photos:'Fotos innen',p1:'1 Foto',p2:'2 Fotos',incl:'inklusive',front:'Au\u00dfen',inside:'Innen',live:'LIVE-VORSCHAU',yours:'Deine Fotos',photo:'Foto',pick:'Foto ausw\u00e4hlen',change:'\u00c4ndern',drag:'Verschieben & zoomen',eng:'Gravur au\u00dfen',with:'Name & Text',ini:'Initiale',without:'Ohne',kS:'Gravur-Stil',iniHint:'Ein gro\u00dfer Buchstabe \u2013 darunter optional ein Datum.',l1:'Zeile 1',l2:'Zeile 2 (optional)',ph1:'z. B. Emma',ph2:'z. B. 12.03.2018',letter:'Buchstabe',phL:'z. B. L',name:'Name',date:'Datum (optional)',dph:'TT.MM.JJJJ',fam:'Namen (bis zu 4)',phF:['Emma','Paul','Mia','Noah'],hint:'Gravur in eleganter Schreibschrift \u2013 wir gravieren genau so, wie du es eingibst. Fotos werden auf Hochglanz gedruckt und von uns eingesetzt. Inklusive Satinbeutel.',errP:'Bitte lade f\u00fcr jedes Foto ein Bild hoch.',errE:'Bitte gib deine Gravur ein.',errD:'Bitte pr\u00fcf das Datum \u2013 z. B. 12.03.2018, 12.03.18 oder 12.03.',kG:'Gravur',kP:'Foto',kN:'ohne Gravur',ban:'Du bearbeitest einen Artikel aus deinem Warenkorb. Beim Hinzuf\u00fcgen wird er ersetzt.',big:'Bitte w\u00e4hle ein Bild (JPG, PNG oder HEIC).',feat:'Kette 45 cm'},
en:{color:'Colour',silver:'Silver',gold:'Gold',photos:'Photos inside',p1:'1 photo',p2:'2 photos',incl:'included',front:'Outside',inside:'Inside',live:'LIVE PREVIEW',yours:'Your photos',photo:'Photo',pick:'Choose photo',change:'Change',drag:'Drag & zoom',eng:'Engraving outside',with:'Name & text',ini:'Initial',without:'None',kS:'Engraving style',iniHint:'One large letter \u2013 optionally with a date below.',l1:'Line 1',l2:'Line 2 (optional)',ph1:'e.g. Emma',ph2:'e.g. 12.03.2018',letter:'Letter',phL:'e.g. L',name:'Name',date:'Date (optional)',dph:'DD.MM.YYYY',fam:'Names (up to 4)',phF:['Emma','Paul','Mia','Noah'],hint:'Engraved in an elegant script \u2013 exactly as you type it. Photos are printed in high gloss and fitted by us. Satin pouch included.',errP:'Please upload a picture for every photo.',errE:'Please enter your engraving.',errD:'Please check the date \u2013 e.g. 12.03.2018, 12.03.18 or 12.03.',kG:'Engraving',kP:'Photo',kN:'no engraving',ban:'You are editing an item from your cart. Adding it will replace the old one.',big:'Please choose an image (JPG, PNG or HEIC).',feat:'45 cm chain'},
sv:{color:'F\u00e4rg',silver:'Silver',gold:'Guld',photos:'Foton inuti',p1:'1 foto',p2:'2 foton',incl:'ing\u00e5r',front:'Utsida',inside:'Insida',live:'LIVEF\u00d6RHANDSVISNING',yours:'Dina foton',photo:'Foto',pick:'V\u00e4lj foto',change:'\u00c4ndra',drag:'Flytta & zooma',eng:'Gravyr p\u00e5 utsidan',with:'Namn & text',ini:'Initial',without:'Ingen',kS:'Gravyrstil',iniHint:'En stor bokstav \u2013 valfritt med ett datum under.',l1:'Rad 1',l2:'Rad 2 (valfritt)',ph1:'t.ex. Emma',ph2:'t.ex. 12.03.2018',letter:'Bokstav',phL:'t.ex. L',name:'Namn',date:'Datum (valfritt)',dph:'DD.MM.\u00c5\u00c5\u00c5\u00c5',fam:'Namn (upp till 4)',phF:['Emma','Paul','Mia','Noah'],hint:'Graveras i en elegant skrivstil \u2013 exakt som du skriver. Fotona trycks i h\u00f6gglans och s\u00e4tts in av oss. Satinp\u00e5se ing\u00e5r.',errP:'Ladda upp en bild f\u00f6r varje foto.',errE:'Ange din gravyr.',errD:'Kontrollera datumet \u2013 t.ex. 12.03.2018, 12.03.18 eller 12.03.',kG:'Gravyr',kP:'Foto',kN:'utan gravyr',ban:'Du \u00e4ndrar en artikel fr\u00e5n din varukorg. N\u00e4r du l\u00e4gger till ers\u00e4tts den gamla.',big:'V\u00e4lj en bild (JPG, PNG eller HEIC).',feat:'Kedja 45 cm'},
fi:{color:'V\u00e4ri',silver:'Hopea',gold:'Kulta',photos:'Kuvat sis\u00e4ll\u00e4',p1:'1 kuva',p2:'2 kuvaa',incl:'sis\u00e4ltyy',front:'Ulkopuoli',inside:'Sis\u00e4puoli',live:'ESIKATSELU',yours:'Kuvasi',photo:'Kuva',pick:'Valitse kuva',change:'Vaihda',drag:'Siirr\u00e4 & zoomaa',eng:'Kaiverrus ulkopuolelle',with:'Nimi & teksti',ini:'Nimikirjain',without:'Ei',kS:'Kaiverrustyyli',iniHint:'Yksi suuri kirjain \u2013 halutessasi p\u00e4iv\u00e4m\u00e4\u00e4r\u00e4 alle.',l1:'Rivi 1',l2:'Rivi 2 (valinnainen)',ph1:'esim. Emma',ph2:'esim. 12.03.2018',letter:'Kirjain',phL:'esim. L',name:'Nimi',date:'P\u00e4iv\u00e4m\u00e4\u00e4r\u00e4 (valinnainen)',dph:'PP.KK.VVVV',fam:'Nimet (enint\u00e4\u00e4n 4)',phF:['Emma','Paul','Mia','Noah'],hint:'Kaiverrus tyylikk\u00e4\u00e4ll\u00e4 k\u00e4sialafontilla \u2013 juuri niin kuin kirjoitat. Kuvat tulostetaan kiilt\u00e4vin\u00e4 ja asennamme ne itse. Satiinipussi sis\u00e4ltyy.',errP:'Lataa kuva jokaiseen kuvapaikkaan.',errE:'Kirjoita kaiverruksesi.',errD:'Tarkista p\u00e4iv\u00e4m\u00e4\u00e4r\u00e4 \u2013 esim. 12.03.2018, 12.03.18 tai 12.03.',kG:'Kaiverrus',kP:'Kuva',kN:'ilman kaiverrusta',ban:'Muokkaat ostoskorisi tuotetta. Lis\u00e4tt\u00e4ess\u00e4 vanha korvataan.',big:'Valitse kuva (JPG, PNG tai HEIC).',feat:'Ketju 45 cm'}
};
var t = T[L] || T.de;
/* Bestseller-Pill neben dem Preis (wie n23-pills bei Inari) */
(function(){
  var BS = {de:'Bestseller',en:'Bestseller',sv:'B\u00e4sts\u00e4ljare',fi:'Myydyin'}[L] || 'Bestseller';
  function addBadge(){
    var pp = document.querySelector('product-price');
    if (!pp || pp.querySelector('.n23m-bs, .n23pl__badge')) return;
    pp.classList.add('n23m-bsrow');
    var b = document.createElement('span'); b.className = 'n23m-bs'; b.textContent = BS;
    pp.appendChild(b);
  }
  addBadge();
  var pp0 = document.querySelector('product-price');
  if (pp0 && window.MutationObserver) new MutationObserver(addBadge).observe(pp0, {childList:true});
})();
var MAXL = 14, MAXN = 12, MAXF = 10;
/* Geometrie der Vorschau-Bilder (Anteile der Bildbreite/-hoehe) */
var GEO = {
s:{ closed:'n23-med-closed-s.png', open:'n23-med-open-s.png', oar:1.2396, ovals:[[0.0732,0.3376,0.3367,0.5862],[0.5739,0.3321,0.3426,0.5935]] },
g:{ closed:'n23-med-closed-g.png', open:'n23-med-open-g.png', oar:1.2555, ovals:[[0.0791,0.3143,0.3426,0.5974],[0.5622,0.3235,0.3558,0.5882]] }
};
var CAR = 0.575; /* Seitenverhaeltnis geschlossen (inkl. Oese) */
var PH_AR = 0.72; /* Foto-Zuschnitt B:H */

var state = { color:'s', n:1, eng:true, em:'text', i1:'', i2:'', l1:'', l2:'', fam:['','','',''], photos:[null,null] };
var P = null;

function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
function $(s){ return root.querySelector(s); }
function isInit(){ return DESIGN === 'initial' || (DESIGN === 'foto' && state.em === 'initial'); }
function img(n){ return CDN + n + '?width=900'; }

/* ---------- Markup ---------- */
function engFields(){
if (DESIGN === 'initial') return '<div class="n23m-two"><label class="n23m-in n23m-in--s"><span>' + esc(t.letter) + '</span><input type="text" data-k="l1" maxlength="1" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="' + esc(t.phL) + '"></label>' +
'<label class="n23m-in"><span>' + esc(t.date) + '</span><input type="text" data-k="l2" maxlength="10" inputmode="decimal" autocomplete="off" placeholder="' + esc(t.dph) + '"></label></div>';
if (DESIGN === 'namedate') return '<div class="n23m-two"><label class="n23m-in"><span>' + esc(t.name) + '</span><input type="text" data-k="l1" maxlength="' + MAXN + '" autocomplete="off" spellcheck="false" placeholder="' + esc(t.ph1) + '"><small data-c="l1">0/' + MAXN + '</small></label>' +
'<label class="n23m-in"><span>' + esc(t.date) + '</span><input type="text" data-k="l2" maxlength="10" inputmode="decimal" autocomplete="off" placeholder="' + esc(t.dph) + '"></label></div>';
if (DESIGN === 'family') { var h = '<div class="n23m-fam">'; for (var i = 0; i < 4; i++) h += '<label class="n23m-in"><input type="text" data-k="f' + i + '" maxlength="' + MAXF + '" autocomplete="off" spellcheck="false" placeholder="' + esc((i ? '' : t.ph1.replace('Emma','')) + t.phF[i]) + '" aria-label="' + esc(t.name + ' ' + (i+1)) + '"></label>'; return h + '</div>'; }
return '<div class="n23m-seg n23m-seg--3" data-eng-seg><button type="button" data-em="text" class="is-on">' + esc(t.with) + '</button><button type="button" data-em="initial">' + esc(t.ini) + '</button><button type="button" data-em="none">' + esc(t.without) + '</button></div>' +
'<div class="n23m-two" data-ef="text"><label class="n23m-in"><span>' + esc(t.l1) + '</span><input type="text" data-k="l1" maxlength="' + MAXL + '" autocomplete="off" spellcheck="false" placeholder="' + esc(t.ph1) + '"><small data-c="l1">0/' + MAXL + '</small></label>' +
'<label class="n23m-in"><span>' + esc(t.l2) + '</span><input type="text" data-k="l2" maxlength="' + MAXL + '" autocomplete="off" spellcheck="false" placeholder="' + esc(t.ph2) + '"><small data-c="l2">0/' + MAXL + '</small></label></div>' +
'<div class="n23m-two" data-ef="initial" style="display:none"><label class="n23m-in n23m-in--s"><span>' + esc(t.letter) + '</span><input type="text" data-k="i1" maxlength="1" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="' + esc(t.phL) + '"></label>' +
'<label class="n23m-in"><span>' + esc(t.date) + '</span><input type="text" data-k="i2" maxlength="10" inputmode="decimal" autocomplete="off" placeholder="' + esc(t.dph) + '"></label></div>' +
'<p class="n23m__hint n23m__hint--i" data-ef="initial" style="display:none">' + esc(t.iniHint) + '</p>';
}
root.innerHTML =
'<div class="n23m__row"><span class="n23m__lbl">' + esc(t.color) + ': <b data-cname>' + esc(t.silver) + '</b></span><div class="n23m-sw">' +
'<button type="button" data-c="s" class="is-on" aria-label="' + esc(t.silver) + '"><i style="background:linear-gradient(135deg,#f4f4f4,#b9bcc0)"></i></button>' +
'<button type="button" data-c="g" aria-label="' + esc(t.gold) + '"><i style="background:linear-gradient(135deg,#f6dc8e,#c9993a)"></i></button></div></div>' +
'<div class="n23m__field"><span class="n23m__lbl">' + esc(t.photos) + '</span><div class="n23m-seg" data-n-seg><button type="button" data-n="1" class="is-on">' + esc(t.p1) + ' <em>' + esc(t.incl) + '</em></button><button type="button" data-n="2">' + esc(t.p2) + ' <em data-plus></em></button></div></div>' +
'<div class="n23m-pv" aria-hidden="true"><span class="n23m-pv__pill">' + esc(t.live) + '</span>' +
'<figure class="n23m-pv__c"><div class="n23m-closed"><img data-closed alt=""><div class="n23m-eng" data-engpv></div></div><figcaption>' + esc(t.front) + '</figcaption></figure>' +
'<figure class="n23m-pv__o"><div class="n23m-open"><div class="n23m-ph" data-o="0"></div><div class="n23m-ph" data-o="1"></div><img data-open alt=""></div><figcaption>' + esc(t.inside) + '</figcaption></figure></div>' +
'<div class="n23m__field"><span class="n23m__lbl">' + esc(t.yours) + '</span><div class="n23m-slots"></div></div>' +
'<div class="n23m__field"><span class="n23m__lbl">' + esc(t.eng) + '</span>' + engFields() + '</div>' +
'<p class="n23m__hint">' + esc(t.hint) + '</p>' +
'<p class="n23m__err" data-err></p>' +
'<div class="n23m-hidden"></div>';

/* ---------- Varianten ---------- */
function groups(){ var vp = document.querySelector('variant-picker'); return vp ? [].slice.call(vp.querySelectorAll('fieldset.variant-option')) : []; }
function pickOpt(gi, idx){
var fs = groups()[gi]; if (!fs) return;
var ins = fs.querySelectorAll('input[type=radio]');
if (ins.length) { var r = ins[idx]; if (r && !r.checked) r.click(); return; }
var s = fs.querySelector('select'); if (s && s.options[idx] && s.selectedIndex !== idx) { s.selectedIndex = idx; s.dispatchEvent(new Event('change', { bubbles:true })); }
}
function checkedIdx(gi){ var fs = groups()[gi]; if (!fs) return -1; var ins = [].slice.call(fs.querySelectorAll('input[type=radio]')); for (var i = 0; i < ins.length; i++) if (ins[i].checked) return i; var s = fs.querySelector('select'); return s ? s.selectedIndex : -1; }
function readVariant(){
var c = checkedIdx(0), n = checkedIdx(1);
if (c >= 0) { var cc = c === 1 ? 'g' : 's'; if (cc !== state.color) setColor(cc, true); }
if (n >= 0 && n + 1 !== state.n) setN(n + 1, true);
}
function money(c){
try { return new Intl.NumberFormat(L === 'en' ? 'en-IE' : L === 'sv' ? 'sv-SE' : L === 'fi' ? 'fi-FI' : 'de-DE', { style:'currency', currency:(window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(c / 100).replace(/\s/g, ''); }
catch(e) { return (c / 100).toFixed(2).replace('.', ',') + ' \u20ac'; }
}
function plusLabel(){
if (!P) return; var a = null, b = null;
P.variants.forEach(function(v){ if (v.option1 !== P.variants[0].option1) return; if (v === P.variants[0] || a == null) { if (a == null) a = v.price; } });
P.variants.forEach(function(v){ var oi = P.options[1] && P.options[1].values ? P.options[1].values.indexOf(v.option2) : -1; if (oi === 0 && (a == null || v.price < a)) a = v.price; if (oi === 1 && (b == null || v.price < b)) b = v.price; });
var el = $('[data-plus]'); if (el && a != null && b != null && b > a) el.textContent = '+' + money(b - a);
}

/* ---------- Farbe / Anzahl ---------- */
function setColor(c, fromVariant){
state.color = c;
root.querySelectorAll('[data-c]').forEach(function(b){ if (b.tagName === 'BUTTON') { var on = b.getAttribute('data-c') === c; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); } });
$('[data-cname]').textContent = c === 'g' ? t.gold : t.silver;
root.setAttribute('data-color', c);
$('[data-closed]').src = img(GEO[c].closed); $('[data-open]').src = img(GEO[c].open);
layoutOpen(); renderEng();
if (!fromVariant) pickOpt(0, c === 'g' ? 1 : 0);
}
function setN(n, fromVariant){
state.n = n === 2 ? 2 : 1;
root.querySelectorAll('[data-n]').forEach(function(b){ var on = +b.getAttribute('data-n') === state.n; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
renderSlots(); renderPhotos(); syncHidden();
if (!fromVariant) pickOpt(1, state.n - 1);
}

/* ---------- Vorschau ---------- */
/* 1 Foto: rechte Haelfte (Seite mit Oese), 2 Fotos: links + rechts */
function slotOval(i){ return state.n === 1 ? 1 : i; }
function layoutOpen(){
var g = GEO[state.color];
root.querySelectorAll('.n23m-ph').forEach(function(el){
var o = g.ovals[+el.getAttribute('data-o')];
el.style.left = (o[0] * 100) + '%'; el.style.top = (o[1] * 100) + '%'; el.style.width = (o[2] * 100) + '%'; el.style.height = (o[3] * 100) + '%';
});
$('.n23m-open').style.aspectRatio = String(g.oar);
}
function renderPhotos(){
var ph = root.querySelectorAll('.n23m-ph'); ph[0].innerHTML = ''; ph[1].innerHTML = '';
ph[0].classList.remove('is-on'); ph[1].classList.remove('is-on');
for (var i = 0; i < state.n; i++) {
var el = ph[slotOval(i)], p = state.photos[i];
el.classList.add('is-on');
el.innerHTML = p && p.url ? '<img src="' + p.url + '" alt="">' : '<span class="n23m-ph__e">' + esc(t.photo) + (state.n > 1 ? ' ' + (i + 1) : '') + '</span>';
}
}
function lines(){
if (DESIGN === 'family') return state.fam.map(function(x){ return x.trim(); }).filter(Boolean);
if (DESIGN === 'foto' && state.em === 'none') return [];
if (DESIGN === 'foto' && state.em === 'initial') return [state.i1.trim(), dclean(state.i2.trim())].filter(Boolean);
return [state.l1.trim(), dclean(state.l2.trim())].filter(Boolean);
}
function demoLines(){
if (isInit()) return ['L', '12.03.2018'];
if (DESIGN === 'family') return t.phF.slice();
if (DESIGN === 'foto' && state.em === 'none') return [];
return ['Emma', '12.03.2018'];
}
function renderEng(){
var box = $('[data-engpv]'); var ls = lines(), demo = false;
if (!ls.length) { ls = demoLines(); demo = true; }
box.classList.toggle('is-demo', demo);
box.classList.toggle('is-initial', isInit());
box.innerHTML = ls.map(function(x, i){ return '<span class="n23m-eng__l' + (i === 0 ? ' n23m-eng__l--1' : '') + '">' + esc(x) + '</span>'; }).join('');
fitEng();
}
function fitEng(){
var box = $('[data-engpv]'), cl = $('.n23m-closed'); if (!box || !cl) return;
var W = cl.clientWidth || 120, ls = box.querySelectorAll('span'), n = ls.length || 1;
var maxW = W * 0.62, base;
var ini = isInit();
if (ini) base = W * 0.36; else base = W * (n <= 1 ? 0.2 : n === 2 ? 0.17 : n === 3 ? 0.135 : 0.115);
ls.forEach(function(s, i){
var f = base; if (ini && i > 0) f = W * 0.1;
if (!ini && DESIGN !== 'family' && i > 0) f = base * 0.78;
s.style.fontSize = f + 'px'; s.style.transform = '';
var w = s.offsetWidth; if (w > maxW) s.style.transform = 'scale(' + (maxW / w) + ')';
});
}
window.addEventListener('resize', fitEng);
if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitEng);
if (window.ResizeObserver) new ResizeObserver(fitEng).observe($('.n23m-closed'));

/* ---------- Foto-Slots + Zuschnitt ---------- */
function renderSlots(){
var h = '';
for (var i = 0; i < state.n; i++) {
var p = state.photos[i];
h += '<div class="n23m-slot" data-s="' + i + '">' +
(p && p.bm ? '<div class="n23m-crop"><canvas width="' + Math.round(240 * PH_AR) + '" height="240"></canvas><span class="n23m-crop__hint">' + esc(t.drag) + '</span></div>' +
'<div class="n23m-slot__ctl"><span class="n23m-slot__t">' + esc(t.photo) + (state.n > 1 ? ' ' + (i + 1) : '') + '</span><input type="range" min="1" max="3" step="0.01" value="' + p.z + '" data-z aria-label="Zoom"><label class="n23m-btn n23m-btn--l">' + esc(t.change) + '<input type="file" accept="image/*" data-file hidden></label></div>'
: '<label class="n23m-up"><input type="file" accept="image/*" data-file hidden><b>+</b><span>' + esc(t.pick) + (state.n > 1 ? ' (' + (i + 1) + ')' : '') + '</span></label>') +
'</div>';
}
$('.n23m-slots').innerHTML = h;
root.querySelectorAll('.n23m-slot').forEach(function(s){ var i = +s.getAttribute('data-s'); var c = s.querySelector('canvas'); if (c) { drawCrop(i); bindCrop(i, c); } });
}
function loadFile(i, file){
if (!file || !/^image\//.test(file.type || 'image/')) { showErr(t.big); return; }
var url = URL.createObjectURL(file);
var im = new Image();
im.onload = function(){
state.photos[i] = { bm:im, x:0, y:0, z:1, url:'', file:null };
hideErr(); renderSlots(); exportCrop(i);
};
im.onerror = function(){ showErr(t.big); };
im.src = url;
}
function cropRect(p, W, H){
var s = Math.max(W / p.bm.naturalWidth, H / p.bm.naturalHeight) * p.z;
var dw = p.bm.naturalWidth * s, dh = p.bm.naturalHeight * s;
var mx = Math.max(0, (dw - W) / 2), my = Math.max(0, (dh - H) / 2);
p.x = Math.max(-mx, Math.min(mx, p.x)); p.y = Math.max(-my, Math.min(my, p.y));
return { x:(W - dw) / 2 + p.x, y:(H - dh) / 2 + p.y, w:dw, h:dh };
}
function drawCrop(i){
var s = root.querySelector('.n23m-slot[data-s="' + i + '"] canvas'), p = state.photos[i]; if (!s || !p) return;
var x = s.getContext('2d'), W = s.width, H = s.height, r = cropRect(p, W, H);
x.clearRect(0, 0, W, H); x.drawImage(p.bm, r.x, r.y, r.w, r.h);
x.save(); x.fillStyle = 'rgba(255,255,255,.62)'; x.beginPath(); x.rect(0, 0, W, H); x.ellipse(W / 2, H / 2, W / 2 - 3, H / 2 - 3, 0, 0, Math.PI * 2, true); x.fill('evenodd');
x.strokeStyle = 'rgba(0,0,0,.35)'; x.lineWidth = 1.5; x.beginPath(); x.ellipse(W / 2, H / 2, W / 2 - 3, H / 2 - 3, 0, 0, Math.PI * 2); x.stroke(); x.restore();
}
var expT = [];
function exportCrop(i){
clearTimeout(expT[i]);
expT[i] = setTimeout(function(){
var p = state.photos[i]; if (!p || !p.bm) return;
var W = 720, H = Math.round(720 / PH_AR), c = document.createElement('canvas'); c.width = W; c.height = H;
var sc = root.querySelector('.n23m-slot[data-s="' + i + '"] canvas'); var f = sc ? W / sc.width : 1;
var q = { bm:p.bm, x:p.x * f, y:p.y * f, z:p.z }, r = cropRect(q, W, H);
var x = c.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, W, H); x.drawImage(p.bm, r.x, r.y, r.w, r.h);
c.toBlob(function(b){
if (!b) return;
if (p.url) try { URL.revokeObjectURL(p.url); } catch(e){}
p.url = URL.createObjectURL(b);
p.file = new File([b], 'foto-' + (i + 1) + '.jpg', { type:'image/jpeg' });
renderPhotos(); syncHidden();
}, 'image/jpeg', 0.9);
}, 120);
}
function bindCrop(i, cv){
var drag = null;
cv.addEventListener('pointerdown', function(e){ drag = { x:e.clientX, y:e.clientY }; try { cv.setPointerCapture(e.pointerId); } catch(_){} e.preventDefault(); });
cv.addEventListener('pointermove', function(e){
if (!drag) return; var p = state.photos[i], k = cv.width / cv.getBoundingClientRect().width;
p.x += (e.clientX - drag.x) * k; p.y += (e.clientY - drag.y) * k; drag = { x:e.clientX, y:e.clientY }; drawCrop(i);
});
function end(){ if (drag) { drag = null; exportCrop(i); } }
cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
}
root.addEventListener('change', function(e){
var el = e.target;
if (el.matches && el.matches('[data-file]')) { var s = el.closest('.n23m-slot'); if (s && el.files && el.files[0]) loadFile(+s.getAttribute('data-s'), el.files[0]); }
});
root.addEventListener('input', function(e){
var el = e.target;
if (el.matches && el.matches('[data-z]')) { var s = el.closest('.n23m-slot'), i = +s.getAttribute('data-s'); state.photos[i].z = +el.value; drawCrop(i); exportCrop(i); return; }
var k = el.getAttribute && el.getAttribute('data-k'); if (!k) return;
var nv;
if ((DESIGN === 'initial' && k === 'l1') || k === 'i1') nv = cleanTxt(el.value).replace(/[^A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u00ff]/g, '').toUpperCase().slice(0, 1);
else if (((DESIGN === 'initial' || DESIGN === 'namedate') && k === 'l2') || k === 'i2') nv = cleanDate(el.value);
else nv = cleanTxt(el.value);
if (nv !== el.value) { var pos = el.selectionStart - (el.value.length - nv.length); el.value = nv; try { el.setSelectionRange(pos, pos); } catch(_){} }
if (k === 'l1') state.l1 = el.value; else if (k === 'l2') state.l2 = el.value; else if (k === 'i1') state.i1 = el.value; else if (k === 'i2') state.i2 = el.value; else state.fam[+k.slice(1)] = el.value;
var sm = root.querySelector('[data-c="' + k + '"]'); if (sm && sm.tagName === 'SMALL') sm.textContent = el.value.length + '/' + el.maxLength;
el.classList.remove('is-err'); hideErr();
renderEng(); syncHidden();
});
root.addEventListener('click', function(e){
var b = e.target.closest && e.target.closest('button'); if (!b || !root.contains(b)) return;
if (b.hasAttribute('data-c')) setColor(b.getAttribute('data-c'));
else if (b.hasAttribute('data-n')) setN(+b.getAttribute('data-n'));
else if (b.hasAttribute('data-em')) setEm(b.getAttribute('data-em'));
});
function setEm(m){
state.em = m; state.eng = m !== 'none';
root.querySelectorAll('[data-em]').forEach(function(b){ var x = b.getAttribute('data-em') === m; b.classList.toggle('is-on', x); b.setAttribute('aria-pressed', x ? 'true' : 'false'); });
root.querySelectorAll('[data-ef]').forEach(function(f){ f.style.display = f.getAttribute('data-ef') === m ? '' : 'none'; });
hideErr(); renderEng(); syncHidden();
}
function setEng(on){ setEm(on ? 'text' : 'none'); }
/* nur Zeichen, die es auf der Tastatur gibt */
function cleanTxt(v){ return String(v).replace(/[^A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u00ff\u0100-\u017f0-9 .,&'!?+\/\-]/g, ''); }
function cleanDate(v){ return String(v).replace(/[^0-9.]/g, '').replace(/\.{2,}/g, '.').replace(/^\./, '').slice(0, 10); }
function dclean(d){ return String(d || '').replace(/\.+$/, ''); }
function dateOk(d){ var m = /^(\d{1,2})\.(\d{1,2})(?:\.(\d{2}|\d{4}))?$/.exec(d); return !!m && +m[1] >= 1 && +m[1] <= 31 && +m[2] >= 1 && +m[2] <= 12; }
function showErr(m){ var er = $('[data-err]'); er.textContent = m; er.classList.add('is-on'); }
function hideErr(){ $('[data-err]').classList.remove('is-on'); }

/* ---------- Line-Item-Properties ---------- */
var DT = (function(){ try { new DataTransfer(); return true; } catch(e){ return false; } })();
function syncHidden(){
var box = $('.n23m-hidden'), ls = lines();
var h = '<input type="hidden" form="' + esc(FORM) + '" name="properties[' + esc(t.kG) + ']" value="' + esc(ls.length ? ls.join(' / ') : t.kN) + '">';
if (DESIGN === 'foto' && state.em === 'initial') h += '<input type="hidden" form="' + esc(FORM) + '" name="properties[' + esc(t.kS) + ']" value="' + esc(t.ini) + '">';
box.innerHTML = h;
for (var i = 0; i < state.n; i++) {
var p = state.photos[i]; if (!p || !p.file) continue;
var inp = document.createElement('input'); inp.type = 'file'; inp.hidden = true; inp.setAttribute('form', FORM); inp.name = 'properties[_' + t.kP + ' ' + (i + 1) + ']';
if (DT) { var d = new DataTransfer(); d.items.add(p.file); inp.files = d.files; box.appendChild(inp); }
}
if (!DT) { /* Fallback: Original-Datei direkt hochladen */
root.querySelectorAll('.n23m-slot').forEach(function(s){ var i = +s.getAttribute('data-s'), f = s.querySelector('[data-file]'); if (f && f.files && f.files.length) { f.setAttribute('form', FORM); f.name = 'properties[_' + t.kP + ' ' + (i + 1) + ']'; } });
}
}

/* ---------- Pruefung vor dem Warenkorb ---------- */
function validate(){
var msg = '', bad = null;
for (var i = 0; i < state.n; i++) { var p = state.photos[i]; if (!p || !p.file) { msg = t.errP; bad = root.querySelector('.n23m-slot[data-s="' + i + '"]'); break; } }
var needEng = DESIGN !== 'foto' || state.em !== 'none';
var fi = DESIGN === 'foto' && state.em === 'initial';
if (!msg && needEng) {
var first = DESIGN === 'family' ? root.querySelector('[data-k=f0]') : root.querySelector(fi ? '[data-k=i1]' : '[data-k=l1]');
if (!lines().length || (DESIGN !== 'family' && !(fi ? state.i1 : state.l1).trim())) { msg = t.errE; bad = first; if (first) first.classList.add('is-err'); }
else if ((DESIGN === 'initial' || DESIGN === 'namedate' || fi) && (fi ? state.i2 : state.l2)) { var d = dclean(fi ? state.i2 : state.l2); if (!dateOk(d)) { msg = t.errD; bad = root.querySelector(fi ? '[data-k=i2]' : '[data-k=l2]'); bad.classList.add('is-err'); } }
}
syncHidden();
if (msg) { showErr(msg); if (bad) { if (bad.focus) try { bad.focus({ preventScroll:true }); } catch(_){} bad.scrollIntoView({ behavior:'smooth', block:'center' }); } return false; }
return true;
}
document.addEventListener('submit', function(e){
var f = e.target; if (!f || f.id !== FORM) return;
if (!validate()) { e.preventDefault(); e.stopImmediatePropagation(); }
}, true);
document.addEventListener('click', function(e){
var btn = e.target.closest && e.target.closest('button[type=submit], button[name=add], .add-to-cart-button');
if (!btn) return; var f = document.getElementById(FORM);
if (f && (btn.form === f || f.contains(btn)) && !validate()) { e.preventDefault(); e.stopPropagation(); }
}, true);
document.addEventListener('change', function(e){ if (e.target && e.target.closest && e.target.closest('variant-picker')) setTimeout(readVariant, 60); });
document.addEventListener('variant:update', function(){ setTimeout(readVariant, 60); });

/* ---------- Info-Leiste: "Verstellbare Groesse" passt nicht zur Kette ---------- */
function fixInfo(){
document.querySelectorAll('.n23i__icons > *').forEach(function(b){
if (/verstellbar|adjustable|justerbar|s\u00e4\u00e4dett/i.test(b.textContent)) {
for (var k = b.childNodes.length - 1; k >= 0; k--) { var nd = b.childNodes[k]; if (nd.nodeType === 3 && nd.textContent.trim()) { nd.textContent = t.feat; return; } }
}
});
}
fixInfo(); setTimeout(fixInfo, 600);

/* ---------- Start ---------- */
setColor('s', true); setN(1, true); renderEng(); syncHidden();
readVariant();

/* ---------- Bearbeiten aus dem Warenkorb (?n23edit=KEY) ---------- */
(function(){
var EK = null; try { EK = new URLSearchParams(location.search).get('n23edit'); } catch(e){}
if (!EK) return;
fetch('/cart.js', { credentials:'same-origin', cache:'no-store' }).then(function(r){ return r.json(); }).then(function(c){
var it = (c.items || []).filter(function(i){ return i.key === EK; })[0]; if (!it) return;
var p = it.properties || {}, eng = null, ph = [], sty = null;
Object.keys(p).forEach(function(k){
if (/^(Gravur|Engraving|Gravyr|Kaiverrus)$/.test(k)) eng = String(p[k]);
if (/^(Gravur-Stil|Engraving style|Gravyrstil|Kaiverrustyyli)$/.test(k)) sty = String(p[k]);
var m = /^_?(?:Foto|Photo|Kuva)\s+(\d)$/.exec(k); if (m) ph[+m[1] - 1] = String(p[k]);
});
var b = document.createElement('div'); b.className = 'n23m__ban'; b.textContent = '\u270e ' + t.ban; root.insertBefore(b, root.firstChild);
setTimeout(function(){
readVariant();
if (eng != null) {
var ls = /^(ohne Gravur|no engraving|utan gravyr|ilman kaiverrusta)$/.test(eng) ? [] : eng.split(' / ');
if (DESIGN === 'family') { ls.forEach(function(x, i){ if (i < 4) { state.fam[i] = x; var el = root.querySelector('[data-k=f' + i + ']'); if (el) el.value = x; } }); }
else if (!ls.length && DESIGN === 'foto') setEng(false);
else if (DESIGN === 'foto' && sty) { setEm('initial'); state.i1 = ls[0] || ''; state.i2 = ls[1] || ''; var a1 = root.querySelector('[data-k=i1]'), z1 = root.querySelector('[data-k=i2]'); if (a1) a1.value = state.i1; if (z1) z1.value = state.i2; }
else { state.l1 = ls[0] || ''; state.l2 = ls[1] || ''; var a = root.querySelector('[data-k=l1]'), z = root.querySelector('[data-k=l2]'); if (a) a.value = state.l1; if (z) z.value = state.l2; }
renderEng(); syncHidden();
}
ph.forEach(function(u, i){
if (!u) return; if (u.indexOf('//') === 0) u = 'https:' + u;
fetch(u).then(function(r){ return r.blob(); }).then(function(bl){ loadFile(i, new File([bl], 'foto-' + (i + 1) + '.jpg', { type:bl.type || 'image/jpeg' })); }).catch(function(){});
});
}, 500);
}).catch(function(){});
})();
if (HANDLE) {
fetch('/products/' + HANDLE + '.js', { credentials:'same-origin' }).then(function(r){ return r.json(); }).then(function(p){ P = p; plusLabel(); readVariant(); }).catch(function(){});
}
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
})();
